import { render, staticRenderFns } from "./SliceImageFull.vue?vue&type=template&id=2c38d09c&lang=pug&"
import script from "./SliceImageFull.vue?vue&type=script&lang=js&"
export * from "./SliceImageFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports